import request from "@/utils/request";

// 获取站点列表
export function getStopPageList(data) {
  return request({
    url: "/open/stop/page",
    method: "post",
    data: data
  });
}

// 获取站点列表
export function getStopList(name) {
  return request({
    url: "/open/stop/list",
    method: "get",
    params: {
      name: name
    }
  });
}

// 获取站点信息
export function getStop(stationId) {
  return request({
    url: "/open/stop/info?stopId=" + stationId,
    method: "get",
  });
}

// 新增站点
export function addStop(data) {
  return request({
    url: "/open/stop/add",
    method: "post",
    data: data
  });
}

// 修改站点
export function updateStop(data) {
  return request({
    url: "/open/stop/update",
    method: "post",
    data: data
  });
}

// 删除站点
export function deleteStation(stationId) {
  return request({
    url: "/open/station/delete/" + stationId,
    method: "post",
  });
}